import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';

// Brand typography per Colours & Typography.pdf:
// - Display/headings: Mont Heavy (licensed webfont). Substituted with
//   Plus Jakarta Sans (free, geometric sans with similar display feel).
// - Body: Montserrat.
// Import only the weights we actually use to keep bundle size reasonable.
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

import './index.css';

// Self-heal stale-chunk failures. After a deploy, a browser holding an old
// HTML/app bundle requests lazy route chunks by hashes that no longer exist.
// Cloudflare's SPA fallback returns index.html for those, so the dynamic
// import (or vite-react-ssg loader-data JSON fetch) gets HTML and throws
// "Unexpected token '<' ... is not valid JSON" / a preload error. We catch
// those, reload once to pull fresh HTML, and cap retries so a genuine bug
// surfaces instead of looping.
if (typeof window !== 'undefined') {
  const RELOAD_KEY = 'ezc-chunk-reloads';
  const isChunkError = (msg?: string) =>
    typeof msg === 'string' &&
    (msg.includes('is not valid JSON') ||
      msg.includes("Unexpected token '<'") ||
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('error loading dynamically imported module'));
  const maybeReload = () => {
    const count = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (count < 2) {
      sessionStorage.setItem(RELOAD_KEY, String(count + 1));
      window.location.reload();
    }
  };
  window.addEventListener('vite:preloadError', (e) => {
    e.preventDefault();
    maybeReload();
  });
  window.addEventListener('error', (e) => {
    if (isChunkError(e?.message)) maybeReload();
  });
  window.addEventListener('unhandledrejection', (e) => {
    if (isChunkError((e?.reason as Error)?.message)) maybeReload();
  });
  // Reset the counter once a load sticks (so future deploys get fresh retries).
  window.addEventListener('load', () => {
    setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 5000);
  });
}

export const createRoot = ViteReactSSG({ routes });
